// extracted by mini-css-extract-plugin
export default {"navBarContainer":"AdminPanel_navBarContainer__l-r4f","linkTabs":"AdminPanel_linkTabs__GXczL"};